import { render, staticRenderFns } from "./consultationEdit.vue?vue&type=template&id=4ac6becf&scoped=true"
import script from "./consultationEdit.vue?vue&type=script&lang=js"
export * from "./consultationEdit.vue?vue&type=script&lang=js"
import style0 from "./consultationEdit.vue?vue&type=style&index=0&id=4ac6becf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6becf",
  null
  
)

export default component.exports